module.exports = __webpack_public_path__ + "static/media/Mallards-Pond-By-Laws.f9ff480e.pdf";